import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { CenterModule } from '../components/CenterModule/CenterModule';
import { api } from '../TokenManager';

function TwoFactor() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [code, setCode] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handle2FA = async (e) => {
    e.preventDefault();

    const normalizedCode = String(code || '').trim();
    if (!normalizedCode) {
      alert('Enter the 2FA code');
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await api.post('/api/verify-2fa', {
        code: normalizedCode,
      });

      // Access and refresh tokens are HttpOnly cookies. Do not store them in
      // localStorage. The browser sends the cookies automatically.
      localStorage.setItem('currentSession', JSON.stringify(response.data.session || {}));

      login({
        isLoggedIn: true,
        is2FA: true,
        user: response.data.user,
        session: response.data.session,
      });

      navigate('/');
    } catch (error) {
      console.error('[TwoFactor] 2FA failed:', error);
      alert(
        error?.response?.data?.message ||
          error?.response?.data?.error ||
          'Invalid 2FA code'
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="twoFactor">
      <CenterModule>
        <h1 className="title">Two-Factor Authentication</h1>
        <p>Check your email for the 2FA code</p>
        <form onSubmit={handle2FA} className="form">
          <input
            type="text"
            placeholder="Enter 2FA Code"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            className="input"
            required
          />
          <button type="submit" className="verify-button" disabled={isSubmitting}>
            {isSubmitting ? 'Verifying…' : 'Verify'}
          </button>
        </form>
      </CenterModule>
    </div>
  );
}

export default TwoFactor;